import React from 'react';

const BorderedPanel = ({ children, color }) => (
	<div className='bordered-panel' style={{ color: color }}>
		{children}
	</div>
);

export default BorderedPanel;
